import MoneyDisplay from '../../../Common/MoneyDisplay';
import { Button, Space, Table, Tooltip } from 'antd';
import { EditOutlined, UnorderedListOutlined } from '@ant-design/icons';


const TaxTable = ({ data, loading, onOpenIntent, onShowRelated }) => {

      const tableCols = [
        {
            title: 'Datum',
            dataIndex: 'dt_str',
            key: 'dt_str',
        },
        {
            // Output VAT (on incomes/sales) — what you owe to the state.
            title: 'DDV za plačilo',
            dataIndex: 'income',
            key: 'za_placilo',
            render: x => <MoneyDisplay type={'EXPENSE'} val={x} />
        },
        {
            // Input VAT (on expenses/purchases) — deductible.
            title: 'DDV za vračilo',
            dataIndex: 'expense',
            key: 'za_vracilo',
            render: x => <MoneyDisplay type={'INCOME'} val={x} />
        },
        {
            title: 'Δ Neto razlika',
            dataIndex: 'total_tax',
            key: 'difference',
            render: (x, row) => (
                <>
                    <MoneyDisplay type={x > 0 ? 'INCOME' : 'EXPENSE'} val={x} />
                    {row.overridden && (
                        <Tooltip title="Davčni znesek je ročno nastavljen (zaklenjen).">
                            <EditOutlined style={{ color: '#1677ff', marginLeft: 4 }} />
                        </Tooltip>
                    )}
                </>
            )
        },
        {
            title: '',
            key: 'open',
            width: 88,
            render: (_, row) => (
                row.intent_count === 1 && row.intent_id ? (
                    <Space size={4}>
                        {onOpenIntent && (
                            <Tooltip title="Odpri davčno obveznost">
                                <Button size="small" icon={<EditOutlined />} onClick={() => onOpenIntent(row.intent_id)} />
                            </Tooltip>
                        )}
                        {onShowRelated && (
                            <Tooltip title="Pokaži povezane transakcije">
                                <Button size="small" icon={<UnorderedListOutlined />} onClick={() => onShowRelated(row.intent_id)} />
                            </Tooltip>
                        )}
                    </Space>
                ) : null
            )
        },
    ];

    return (
        <Table loading={loading} dataSource={data} columns={tableCols} size="small" pagination={false} />
    )
};

export default TaxTable;
